/**
 * PLATINUM — Vzorci silent-add (v7 — minimal)
 *
 * ─────────────────────────────────────────────────────────────────────
 * Only what is actually needed: the silent-add that powers the one-click
 * acquisition links (Klaviyo / Wisepops). Nothing else.
 *
 * NO CAP. The sample discount codes are FIXED €8.70 (once per order), so the
 * customer already pays for every sample beyond the first 3:
 *   3 samples = €0 · 5 samples = €5.80 (= 3 free + 2 × €2.90).
 * Shopify just spreads the discount visually across the lines (e.g. 5 × €1.16);
 * the amount charged is correct. The fixed amount also caps the free part
 * natively, so there is no abuse to guard against → no cap JS required.
 *
 * Discount code is hardcoded to VZORCI-100 (as in the original) — nothing about
 * the existing links changes.
 *
 * CHANGELOG
 *   2026-06-19 (v7) Stripped to silent-add only (cap/trim/PDP-block/interception
 *               all removed; discounts went 100% → fixed, so the cap is obsolete).
 *
 * BEHAVIOR
 *   URL ?vzorci=pes|macka  → applies VZORCI-100 (cookie) + adds the 3 variants,
 *   customer stays on the page the link points to. No checkout redirect.
 * ─────────────────────────────────────────────────────────────────────
 */
(function () {
  'use strict';

  const VZORCI_HANDLES = ['vzorci-za-pse', 'vzorci-za-macke'];
  const DISCOUNT_CODE = 'VZORCI-100';
  const SET_SIZE = 3; // variants a silent-add adds (for the refresh/back idempotency guard)
  const SILENT_ADD_PARAM = 'vzorci';
  const VARIANT_SETS = {
    pes: [
      { id: 53067994759496, quantity: 1 }, // Adult Chicken
      { id: 53067995971912, quantity: 1 }, // Adult Lamb+Rice
      { id: 53067995906376, quantity: 1 }, // Adult Iberico+Greens
    ],
    macka: [
      { id: 53067994792264, quantity: 1 }, // MeatCrisp Adult Chicken (requires stock!)
      { id: 53067996234056, quantity: 1 }, // MeatCrisp Adult Fish
      { id: 53067996299592, quantity: 1 }, // MeatCrisp Sterilised Fish
    ],
  };

  const originalFetch = window.fetch.bind(window);

  async function fetchCart() {
    try {
      return await (await originalFetch('/cart.js', { credentials: 'same-origin' })).json();
    } catch (e) {
      return { items: [] };
    }
  }

  function vzorciQty(cart) {
    return (cart.items || [])
      .filter((i) => VZORCI_HANDLES.includes(i.handle))
      .reduce((s, i) => s + i.quantity, 0);
  }

  function refreshCartUI() {
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:item-added', { bubbles: true }));
    try {
      originalFetch('/?sections=cart-drawer,cart-icon-bubble', { credentials: 'same-origin' });
    } catch (e) {}
  }

  async function handleSilentAdd() {
    let url;
    try { url = new URL(window.location.href); } catch (e) { return; }

    const trigger = url.searchParams.get(SILENT_ADD_PARAM);
    if (!trigger) return;

    const items = VARIANT_SETS[trigger];
    if (!items) {
      url.searchParams.delete(SILENT_ADD_PARAM);
      try { window.history.replaceState({}, '', url.toString()); } catch (e) {}
      return;
    }

    try {
      // Apply the discount via /discount/CODE (sets cookie → samples show €0 in cart).
      try {
        await originalFetch('/discount/' + DISCOUNT_CODE, { method: 'GET', credentials: 'same-origin' });
      } catch (e) {}

      // Idempotency — skip if the cart already holds a full set (refresh/back guard).
      if (vzorciQty(await fetchCart()) < SET_SIZE) {
        await originalFetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items }),
        });
      }
    } catch (e) {
      console.warn('[Platinum Vzorci] Silent add failed:', e);
    }

    url.searchParams.delete(SILENT_ADD_PARAM);
    url.searchParams.delete('discount');
    try { window.history.replaceState({}, '', url.toString()); } catch (e) {}

    refreshCartUI();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleSilentAdd);
  } else {
    handleSilentAdd();
  }
})();
